import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	missingRequiredData: {
		id: 'reloadSuggestion.missingRequiredData',
		defaultMessage: 'Не удалось отправить сообщение. Обновите страницу и попробуйте еще раз.',
	},
});
